"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var iconButtonLocal = function iconButtonLocal(theme) {
  var stateSuccess = {
    backgroundColor: theme.color.success["default"],
    iconColor: theme.color.monochrome1["default"],
    hover: {
      backgroundColor: theme.color.success.hover,
      iconColor: theme.color.monochrome1["default"]
    },
    pressed: {
      backgroundColor: theme.color.success.pressed,
      iconColor: theme.color.monochrome1["default"]
    },
    inverse: {
      backgroundColor: theme.inverseColor.success["default"],
      iconColor: theme.color.monochrome1["default"],
      hover: {
        backgroundColor: theme.inverseColor.success.hover,
        iconColor: theme.color.monochrome1["default"]
      },
      pressed: {
        backgroundColor: theme.inverseColor.success.pressed,
        iconColor: theme.color.monochrome1["default"]
      }
    }
  };
  var state = {
    success: stateSuccess,
    selected: stateSuccess
  };
  return {
    appearance: {
      primary: {
        backgroundColor: theme.color.primary1["default"],
        iconColor: theme.color.monochrome6["default"],
        border: 'transparent',
        iconAppearance: 'primary',
        loadingSpinnerAppearance: 'primary',
        inverseIcon: false,
        hover: {
          backgroundColor: theme.color.primary1.hover,
          iconColor: theme.color.monochrome1["default"],
          border: 'transparent'
        },
        pressed: {
          backgroundColor: theme.color.primary1.pressed,
          iconColor: theme.color.monochrome1["default"],
          border: 'transparent'
        },
        inverse: {
          backgroundColor: theme.inverseColor.primary1["default"],
          iconColor: theme.color.monochrome6["default"],
          border: 'transparent',
          iconAppearance: 'primary',
          inverseIcon: false,
          hover: {
            backgroundColor: theme.inverseColor.primary1.hover,
            iconColor: theme.inverseColor.monochrome6["default"],
            border: 'transparent'
          },
          pressed: {
            backgroundColor: theme.inverseColor.primary1.pressed,
            iconColor: theme.inverseColor.monochrome6["default"],
            border: 'transparent'
          }
        }
      },
      secondary: {
        backgroundColor: theme.color.monochrome6["default"],
        iconColor: theme.color.primary1["default"],
        border: 'transparent',
        iconAppearance: 'secondary',
        loadingSpinnerAppearance: 'secondary',
        inverseIcon: false,
        hover: {
          backgroundColor: theme.color.monochrome6.hover,
          iconColor: theme.color.primary1["default"],
          border: 'transparent'
        },
        pressed: {
          backgroundColor: theme.color.monochrome6.pressed,
          iconColor: theme.color.monochrome6["default"],
          border: 'transparent'
        },
        inverse: {
          backgroundColor: theme.inverseColor.monochrome6["default"],
          iconColor: theme.color.monochrome6["default"],
          border: 'transparent',
          iconAppearance: 'secondary',
          loadingSpinnerAppearance: 'primary',
          inverseIcon: false,
          hover: {
            backgroundColor: theme.inverseColor.monochrome6.hover,
            iconColor: theme.inverseColor.primary1["default"],
            border: 'transparent'
          },
          pressed: {
            backgroundColor: theme.inverseColor.monochrome6.pressed,
            iconColor: theme.inverseColor.primary1["default"],
            border: 'transparent'
          }
        }
      },
      alt1: {
        backgroundColor: theme.color.monochrome1["default"],
        iconColor: theme.color.monochrome6["default"],
        border: theme.color.monochrome6["default"],
        iconAppearance: 'primary',
        loadingSpinnerAppearance: 'primary',
        inverseIcon: false,
        hover: {
          backgroundColor: theme.color.monochrome6.hover,
          iconColor: theme.color.monochrome1["default"],
          border: theme.color.monochrome6.hover
        },
        pressed: {
          backgroundColor: theme.color.monochrome6.pressed,
          iconColor: theme.color.monochrome1["default"],
          border: theme.color.monochrome6.pressed
        },
        inverse: {
          backgroundColor: theme.inverseColor.monochrome1["default"],
          iconColor: theme.inverseColor.monochrome6["default"],
          border: theme.inverseColor.monochrome6["default"],
          iconAppearance: 'secondary',
          loadingSpinnerAppearance: 'secondary',
          inverseIcon: false,
          hover: {
            backgroundColor: theme.inverseColor.monochrome6.hover,
            iconColor: theme.inverseColor.monochrome1["default"],
            border: theme.inverseColor.monochrome6.hover
          },
          pressed: {
            backgroundColor: theme.inverseColor.monochrome6.pressed,
            iconColor: theme.inverseColor.monochrome1["default"],
            border: theme.inverseColor.monochrome6.pressed
          }
        }
      },
      alt2: {
        backgroundColor: theme.color.monochrome1["default"],
        iconColor: theme.color.monochrome6["default"],
        border: theme.color.primary1["default"],
        iconAppearance: 'primary',
        loadingSpinnerAppearance: 'primary',
        inverseIcon: false,
        hover: {
          backgroundColor: theme.color.primary1.hover,
          iconColor: theme.color.monochrome1["default"],
          border: theme.color.primary1.hover
        },
        pressed: {
          backgroundColor: theme.color.primary1.pressed,
          iconColor: theme.color.monochrome1["default"],
          border: theme.color.primary1.pressed
        },
        inverse: {
          backgroundColor: theme.inverseColor.monochrome1["default"],
          iconColor: theme.inverseColor.monochrome6["default"],
          border: theme.inverseColor.primary1["default"],
          iconAppearance: 'secondary',
          loadingSpinnerAppearance: 'secondary',
          inverseIcon: false,
          hover: {
            backgroundColor: theme.inverseColor.primary1.hover,
            iconColor: theme.inverseColor.monochrome6["default"],
            border: theme.inverseColor.primary1.hover
          },
          pressed: {
            backgroundColor: theme.inverseColor.primary1.pressed,
            iconColor: theme.inverseColor.monochrome6["default"],
            border: theme.inverseColor.primary1.pressed
          }
        }
      }
    },
    state: _objectSpread({}, state),
    size: {
      1: {
        iconSize: 1,
        loadingSpinnerSize: 1,
        sm: {
          buttonSize: 24
        },
        md: {
          buttonSize: 24
        }
      },
      2: {
        iconSize: 2,
        loadingSpinnerSize: 2,
        sm: {
          buttonSize: 32
        },
        md: {
          buttonSize: 32
        }
      },
      3: {
        iconSize: 2,
        loadingSpinnerSize: 2,
        sm: {
          buttonSize: 36
        },
        md: {
          buttonSize: 36
        }
      },
      4: {
        iconSize: 3,
        loadingSpinnerSize: 3,
        sm: {
          buttonSize: 44
        },
        md: {
          buttonSize: 44
        }
      },
      5: {
        iconSize: 3,
        loadingSpinnerSize: 3,
        sm: {
          buttonSize: 48
        },
        md: {
          buttonSize: 48
        }
      },
      6: {
        iconSize: 4,
        loadingSpinnerSize: 4,
        sm: {
          buttonSize: 56
        },
        md: {
          buttonSize: 60
        }
      }
    }
  };
};

var _default = iconButtonLocal;
exports["default"] = _default;
//# sourceMappingURL=IconButton.voxi.theme.js.map